export enum RoleName {
  ADMIN = 'ADMIN',
  MODERATOR = 'MODERATOR',
  GROUP_MANAGER = 'GROUP_MANAGER',
  COMPANY_MANAGER = 'COMPANY_MANAGER',
  BRANCH_MANAGER = 'BRANCH_MANAGER',
  BRANCH_AGENT = 'BRANCH_AGENT',
}
